import { render, staticRenderFns } from "./ntmBlock.vue?vue&type=template&id=4ff0e5bb"
import script from "./ntmBlock.vue?vue&type=script&lang=js"
export * from "./ntmBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports